'use client'
import { useDialogStore, useStoreState } from '@ariakit/react'
import { createContainer } from 'unstated-next'

export type UseFilterModalServiceOpts = {
  initialShouldDisplayFilterModal?: boolean
  initialShouldRenderFilterModal?: boolean
}

function useFilterModalService({
  initialShouldDisplayFilterModal = false,
}: UseFilterModalServiceOpts = {}) {
  const dialogStore = useDialogStore({ defaultOpen: initialShouldDisplayFilterModal })
  const dialogState = useStoreState(dialogStore)

  function openFilterModal(): void {
    dialogStore.setOpen(true)
  }

  function closeFilterModal(): void {
    dialogStore.setOpen(false)
  }

  return {
    dialogStore,
    closeFilterModal,
    openFilterModal,
    shouldDisplayFilterModal: dialogState.open,
  }
}

export const FilterModalService = createContainer(useFilterModalService)
export const FilterModalServiceProvider = FilterModalService.Provider
